import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import type { FormState } from 'ngrx-forms';
import {
  MarkAsDirtyAction,
  MarkAsTouchedAction,
  NgrxFormsModule,
} from 'ngrx-forms';
import { InnogyComponentRendering } from '@core/jss-models';
import { Store } from '@ngrx/store';
import { NgTemplateOutlet } from '@angular/common';
import { GenericRichTextDirective } from '@core/jss-utils';
import { AutomationIdDirective } from '@innogy/utils-automation-id';
import { TrackValueChangeDirective } from '@analytics/events';
import { CSCaptureDirective } from '@legacy/utils-contentsquare';
import { CommonUiUtilityComponentsModule } from '@legacy/common-ui-utility-components';
import { ValidationClassesDirective } from '@innogy/utils-deprecated';

import type { RadioItem } from '../radio/radio.model';

@Component({
  selector: 'wl-radio-bordered',
  templateUrl: './radio-bordered.component.html',
  styleUrls: ['./radio-bordered.essent.scss'],
  standalone: true,
  imports: [
    AutomationIdDirective,
    TrackValueChangeDirective,
    CSCaptureDirective,
    NgTemplateOutlet,
    CommonUiUtilityComponentsModule,
    GenericRichTextDirective,
    NgrxFormsModule,
    AutomationIdDirective,
    ValidationClassesDirective,
  ],
})
export class RadioBorderedComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() formsControl?:
    | FormState<boolean | undefined>
    | FormState<string | undefined>;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() radioItems: RadioItem[] = [];
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering?: InnogyComponentRendering;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() fieldName?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() stepName?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() sendValue = true;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() hashValue = false;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() step?: number;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() label?: string;
  @Output() radioChange = new EventEmitter<RadioItem>();
  active?: RadioItem;

  @ViewChild('trackingWrapper')
  public trackingWrapperRef?: ElementRef<HTMLDivElement>;

  constructor(readonly store$: Store) {}

  public getId(radio: RadioItem, index: number) {
    return radio.id ?? `${this.formsControl?.id}${index}`;
  }

  public trackRadio(_index: number, item: RadioItem) {
    return item.id ?? item.value;
  }

  public onFocus() {
    if (this.formsControl) {
      this.dispatchNativeEvent('focus');
    }
  }

  public onChange(e: any) {
    if (this.formsControl) {
      this.touchControl(this.formsControl);
      this.active = this.radioItems.find(
        (item, index) => this.getId(item, index) === e.target.id
      );
      this.radioChange.emit(this.active);
      this.dispatchNativeEvent('change');
    }
  }

  private touchControl(
    control: FormState<boolean | undefined> | FormState<string | undefined>
  ) {
    this.store$.dispatch(new MarkAsTouchedAction(control.id));
    this.store$.dispatch(new MarkAsDirtyAction(control.id));
  }

  private dispatchNativeEvent(eventName: string) {
    this.trackingWrapperRef?.nativeElement.dispatchEvent(new Event(eventName));
  }

  get radioTrackingValue(): string {
    const radioItem = this.radioItems?.find(
      (r) => r.value === this.formsControl?.value
    );
    return radioItem?.trackingLabel ?? radioItem?.label ?? '';
  }

  get firstEnabledRadioIndex() {
    return this.radioItems.map((v) => v.disabled ?? false).indexOf(false);
  }
}
